import { render, staticRenderFns } from "./collect-detail-modal.vue?vue&type=template&id=96152e3c&scoped=true&"
import script from "./collect-detail-modal.vue?vue&type=script&lang=js&"
export * from "./collect-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./collect-detail-modal.vue?vue&type=style&index=0&id=96152e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96152e3c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96152e3c')) {
      api.createRecord('96152e3c', component.options)
    } else {
      api.reload('96152e3c', component.options)
    }
    module.hot.accept("./collect-detail-modal.vue?vue&type=template&id=96152e3c&scoped=true&", function () {
      api.rerender('96152e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/collect-detail-modal.vue"
export default component.exports